import React, { FunctionComponent } from 'react';
import { View } from '@upstox/upstox-ui';
import * as css from './IPOInfo.style';
import FieldPair from '../../FieldPair';
import moment from 'dayjs';

type Props = {
  biddingStartDate: string;
  biddingEndDate: string;
  lotSize: number;
  issueSize: string;
  minPrice: number;
  minQuantity: number;
  isSeoApp?: boolean;
};

const IPOInfo: FunctionComponent<Props> = ({
  biddingStartDate,
  biddingEndDate,
  lotSize,
  issueSize,
  minPrice,
  minQuantity,
  isSeoApp = false,
}) => {
  const fieldPairData = [
    {
      label: 'Bidding Dates',
      value: biddingStartDate
        ? `${moment(biddingStartDate).format('D')}-${moment(
            biddingEndDate,
          ).format('D MMM')}`
        : '--',
    },
    {
      label: 'Min. Investment',
      value:
        minPrice && minQuantity
          ? `${(minPrice * minQuantity).toLocaleString('en-IN', {
              style: 'currency',
              currency: 'INR',
            })}`
          : '--',
    },
    {
      label: 'Lot Size',
      value: lotSize ? `${lotSize} shares` : '--',
    },
    {
      label: 'Issue Size',
      value:
        issueSize && issueSize !== '0'
          ? `₹${Number(issueSize) / 10000000} Cr`
          : '--',
    },
  ];

  return (
    <View flexWrap="wrap" css={css.ipoInfo}>
      {fieldPairData.map((fieldPair) => (
        <FieldPair
          key={fieldPair.label}
          label={fieldPair.label}
          value={fieldPair.value}
          isSeoApp={isSeoApp}
        />
      ))}
    </View>
  );
};

export default IPOInfo;
